import { Link } from 'react-router-dom';
import { BLOG_POSTS } from '../data/blogPosts';

export default function LatestArticles() {
  const latest = [...BLOG_POSTS].sort((a, b) => b.date.localeCompare(a.date)).slice(0, 4);

  return (
    <section className="py-20 px-4 bg-gray-50/50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
          <div>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">Latest Articles</h2>
            <p className="mt-2 text-gray-600">Guides on resumes, QR codes, and international sizing.</p>
          </div>
          <Link to="/blog" className="text-brand-600 font-medium hover:underline text-sm">
            View all articles →
          </Link>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {latest.map((post) => (
            <article key={post.slug} className="bg-white rounded-2xl p-6 border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
              <span className="text-xs font-medium text-brand-600 bg-brand-50 px-2 py-0.5 rounded-full">
                {post.category}
              </span>
              <h3 className="mt-3 font-semibold text-gray-900 text-lg leading-snug">
                <Link to={`/blog/${post.slug}`} className="hover:text-brand-600 transition-colors">
                  {post.title}
                </Link>
              </h3>
              <p className="mt-2 text-sm text-gray-500 line-clamp-2">{post.excerpt}</p>
              <time className="mt-4 block text-xs text-gray-400" dateTime={post.date}>
                {new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
              </time>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
